import script from "./NotificationMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMenu.vue?vue&type=script&setup=true&lang=js"

import "./styles/NotificationMenu.styles.scss?vue&type=style&index=0&id=258640fb&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258640fb"]])

export default __exports__